import { Link } from 'react-router-dom';
import { productNavCards } from '@/mocks/home';

function ProductNavGrid() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden">
      {/* Subtle decorative blobs */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-primary-500/[0.025] blur-[120px]" />
        <div className="absolute -bottom-60 -right-40 w-[700px] h-[700px] rounded-full bg-accent-500/[0.02] blur-[140px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Section header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">
            全系硬件产品
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4 tracking-tight">
            三大产品生态 · 六大核心硬件
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
            政企批量采购 · 商旅单品选购 — 覆盖全场景 AI 翻译需求
          </p>
        </div>

        {/* Product cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {productNavCards.map((card, idx) => (
            <Link
              key={card.id}
              to={card.href}
              className="group relative bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200/70 transition-all duration-400 cursor-pointer hover:-translate-y-1 hover:shadow-[0_8px_40px_-8px_rgba(0,0,0,0.06)]"
            >
              {/* Image area */}
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={card.imageSrc || `https://readdy.ai/api/search-image?query=$%7Bcard.imageQuery%7D&width=600&height=400&seq=nav-card-${card.id}&orientation=landscape`}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-all duration-600 group-hover:scale-105"
                  loading={idx < 3 ? 'eager' : 'lazy'}
                />

                {/* Series badge — top-left */}
                <span className="absolute top-3.5 left-3.5 px-3 py-1 text-xs font-semibold text-white bg-primary-500/90 backdrop-blur-sm rounded-full">
                  {card.series}
                </span>

                {/* Featured indicator for first card */}
                {idx === 0 && (
                  <span className="absolute top-3.5 right-3.5 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-accent-700 bg-accent-100 rounded-full">
                    旗舰
                  </span>
                )}
              </div>

              {/* Content area */}
              <div className="p-5 md:p-6 relative">
                <h3 className="text-lg font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-300">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  {card.desc}
                </p>

                {/* Explore link */}
                <div className="flex items-center gap-2 text-sm font-medium text-foreground-400 group-hover:text-primary-600 transition-colors duration-300">
                  <span>了解详情</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-300 inline-block"></i>
                </div>
              </div>

              {/* Hover border glow */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-primary-200/60 pointer-events-none transition-all duration-400" />
            </Link>
          ))}
        </div>

        {/* View all link */}
        <div className="mt-12 text-center">
          <Link
            to="/more-products/all-in-one"
            className="inline-flex items-center gap-2.5 px-6 py-3 text-sm font-semibold text-foreground-600 bg-white border border-background-200 rounded-full hover:text-primary-600 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
          >
            查看全部产品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ProductNavGrid;